import { Empty } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// import DeviceCardContainerWrapper from './DeviceCardContainerWrapper.styles';
import { Col, Input, Row } from 'zui/Antd';
import DeviceCardContainerWrapper from './DeviceCardContainerWrapper.styles';

const { Search } = Input;

const DeviceCardsContainer = ({ categoryID }) => {
	const { data: devicesData } = useSelector((state) => state.Devices);

	const [filteredDevices, setFilteredDevices] = useState([]);
	const [devices, setDevices] = useState([]);

	// Get all the devices of the category selected and their customFields.
	useEffect(() => {
		if (devicesData.length > 0) {
			const selectedCategoryDevices = devicesData.filter((item) => item.categoryID === categoryID);

			if (selectedCategoryDevices.length > 0) {
				setDevices(selectedCategoryDevices);
				setFilteredDevices(selectedCategoryDevices);
			} else {
				setFilteredDevices([]);
				setDevices([]);
			}
		}
	}, [devicesData, categoryID]);

	// Searching the devices
	const filter = (array, searchTerm, columns) => {
		const searchResult = array.filter((row) => {
			return columns.some((column) => {
				return String(row[column]).toLowerCase().includes(searchTerm.toLowerCase());
			});
		});
		setFilteredDevices(searchResult);
	};

	return (
		<DeviceCardContainerWrapper>
			<Search
				placeholder='Search by Name or Unique Identification Number'
				enterButton='Search'
				onChange={(event) => {
					filter(devices, event.target.value, ['name', 'uID']);
				}}
				onSearch={(query) => {
					filter(devices, query, ['name', 'uID']);
				}}
				style={{ marginBottom: 10 }}
			/>
			{filteredDevices.length > 0 ? (
				<Row className='cardContainer' gutter={[10, 10]}>
					{filteredDevices.map((item) => {
						return (
							<Col key={item.uID}>
								<item.cardComponent device={item} />
							</Col>
						);
					})}
				</Row>
			) : (
				<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span>No Device Found</span>} />
			)}
		</DeviceCardContainerWrapper>
	);
};

export default DeviceCardsContainer;
